import { useEffect, useState } from 'react';
import { getTimeRemaining } from '@/shared/lib/utils/getTimeRemaining';

export const useRemainingTimer = (time: number, timeAt: number) => {
  const [, setTick] = useState(0);
  const timeRemaining = getTimeRemaining(time, timeAt);
  const isRunning = timeRemaining > 0;

  useEffect(() => {
    if (!isRunning) return;
    const refresh = () => setTick((tick) => tick + 1);
    const interval = setInterval(refresh, 1000);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [time, timeAt, isRunning]);

  return timeRemaining;
};
